import { LayoutType, withLayout } from 'hocs/with-layout';
import { OnboardingPromptCategories } from './onboarding-prompt-categories';

const WrappedOnboardingPromptCategories = withLayout(
  LayoutType.WithOldNavOnly,
  OnboardingPromptCategories,
);

export { WrappedOnboardingPromptCategories as OnboardingPromptCategories };
